import { useMemo } from "react"
import { MaterialReactTable, type MRT_ColumnDef } from "material-react-table"
import { Box } from "@mui/material"
import { useNavigate } from "react-router"
import { useAppSelector } from "../../../redux/hooks"
import { useDispatch, useSelector } from "react-redux"
import {
  setGroupDetailsPracticeresult,
  setSelectedGroupSk,
} from "../../../redux/slices/groupProfileSlice"

export const CustomerTable = (props: any) => {
  const { groupInfoHandler, metricDetailsHandler, groupDetailsHandler } = props

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { loading } = useAppSelector((state: any) => state.app)

  const groupData = useSelector((state: any) => {
    return state.groupProfile.groupData
  })

  const columns = useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "group_name",
        header: "Group Name",
        Cell: ({ row, renderedCellValue }) => (
          <Box
            sx={{
              cursor: "pointer",
              "&:hover": {
                color: "#3D76EF",
              },
            }}
            onClick={() => {
              dispatch(setSelectedGroupSk(row.original.group_sk))
              groupInfoHandler(row?.original?.group_sk)
              metricDetailsHandler(row?.original?.group_sk),
                groupDetailsHandler(row.original.group_sk),
                navigate("/group-profile")
              dispatch(setGroupDetailsPracticeresult([]))
            }}
          >
            {renderedCellValue}
          </Box>
        ),
      },
      {
        accessorKey: "assigned_metrics",
        header: "Assigned Metric(s)",
        Cell: ({ row, renderedCellValue }) => (
          <Box sx={{ color: "#3366D6" }}>{renderedCellValue}</Box>
        ),
      },
      {
        accessorKey: "group_status",
        header: "Status",
        Cell: ({ row, renderedCellValue }) => (
          <Box
            sx={{
              textTransform: "capitalize",
              backgroundColor:
                row?.original?.group_status === "active"
                  ? "#00af50 "
                  : "#ff0000",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              width: "fit-content",
              padding: "0px 1rem",
              height: "32px",
              borderRadius: "5px",
              color: "#fff",
            }}
          >
            {row?.original?.group_status.replace(/_+/g, " ")}
          </Box>
        ),
      },
    ],
    [],
  )

  return (
    <MaterialReactTable
      state={{
        isLoading: loading,
      }}
      columns={columns}
      data={groupData}
      enableStickyHeader={true}
      enableColumnActions={false}
      enableColumnFilters={false}
      enablePagination={false}
      enableSorting={false}
      enableBottomToolbar={false}
      enableTopToolbar={false}
      muiTableBodyRowProps={{ hover: false, sx: { height: "60px" } }}
      muiTableContainerProps={{
        sx: {
          marginTop: "8px",
          height: "auto",
          border: "4px",
        },
      }}
      muiTableHeadCellProps={{
        align: "left",
        sx: {
          backgroundColor: "#3366D6",
          color: "#fff",
          fontSize: "13px",
          border: "0.5px solid #FFFFFF",
          //boxShadow: " #00000022 1.95px  0px 2.6px",
        },
      }}
      muiTableBodyCellProps={{
        align: "left",
        sx: {
          fontSize: "14px",
          // borderBottom: "1px solid #00000022",
          border: "0.5px solid #00000022",
          //boxShadow: "#00000022 1.95px 0px 2.6px",
        },
      }}
    />
  )
}

export default CustomerTable
